<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Epigraph">
<blockquote class="epigraph">
<p class="epitxt"><span aria-label="page ix" id="page_ix" role="doc-pagebreak"><span aria-label="page x" id="page_x" role="doc-pagebreak"><b>F<span class="smallcaps">OR</span>, <span class="smallcaps">IN THE FINAL ANALYSIS</span>,</b></span></span></p>
<p class="epitxt"><i>our most basic common link</i></p>
<p class="epitxt"><b><span class="smallcaps">IS THAT WE ALL INHABIT</span></b></p>
<p class="epitxt"><i>this small planet.</i></p>
<p class="epitxt"><b>W<span class="smallcaps">E ALL BREATHE THE SAME AIR</span>.</b></p>
<p class="epitxt"><i>We all cherish our children’s future.</i></p>
<p class="epitxt"><b>A<span class="smallcaps">ND WE ARE ALL MORTAL</span>.</b></p>
<p class="epinam">—John F. Kennedy</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?ddba4842